import {
  MEM_MAKERS,
  MEM_TAKERS,
  FETCHED_PAIRS,
  ADD_TO_MAKER_MAP,
  MEM_TRANSFERS
} from '../actions/types';

import callBC from '../actions/helpers/bc';
import { toASM,fromASM } from 'bc-sdk/dist/script/bytecode'
import BN from 'bn.js';
import {Decimal} from 'decimal.js';
import {addToPairs, removeFromPairs, modifyPairs} from '../actions/orderbook/get/openOrders';
import {collateralizeFilter} from '../actions/orderbook/filter';
Decimal.set({toExpPos:100})
Decimal.set({toExpNeg:-100})
const { getScriptType, ScriptType, parseMakerLockScript,parseNRGLockScript,parseTakerLockScript, parseTakerUnlockScript } = require('bc-sdk/dist/script/templates')
const { blake2bl } = require('bc-sdk/dist/utils/crypto')
var hash = require('object-hash');

let toVal = (val) => {
  return new Decimal(new BN(Buffer.from(val,'base64')).toString()).div(new Decimal(Math.pow(10,18))).toString()
}

const getTxOwnerHashed = (tx): string => {
  let owner = ''
  for (let input of tx.inputsList) {
    let inputScript = toASM(Buffer.from(input.inputScript), 0x01)
    if (inputScript.split(' ').length === 2) {
      // give the double hashed version of the owner
      owner = inputScript.split(' ')[1]
    }
  }
  return owner
}

export const initMempool = (dispatch, store) => {
  console.log("start mempool")
  setInterval( async ()=>{
    if(!store.getState().socket.connected){
    let mempool = await callBC(store.getState().settings.settings,'getRawMempool',[])
    let maker_map = store.getState().orderbook.maker_map;
    let pairs = store.getState().orderbook.pairs;
    let bcHeight = store.getState().socket.bcHeight
    if(mempool && mempool.result && mempool.result.transactionsList){
      let makers = [];
      let takers = [];
      let transfers = [];
      let addresses = Object.keys(store.getState().passport.nrg);

      for(let i = 0; i < mempool.result.transactionsList.length; i++){
        let tx = mempool.result.transactionsList[i];
        let owner = '';
        let isOwner = false;

        let totalValueIn = new Decimal(0);

        for(let j = 0; j < tx.inputsList.length; j++){
          let {hash,index,value} = tx.inputsList[j].outPoint
          value = toVal(value)
          totalValueIn = totalValueIn.add(new Decimal(value))
          let script = toASM(Buffer.from(tx.inputsList[j].inputScript, "base64"), 0x01)
          if(script.split(' ').length === 2) {
            owner = script.split(' ')[1]
            for(let addr of addresses){
              if(script.includes('0x'+ blake2bl(addr))) {
                owner = addr;
                isOwner = true;
              }
            }
          }
        }

        for(let j = 0; j < tx.outputsList.length; j++){
          let output = tx.outputsList[j]
          let value = toVal(output.value)
          let unit = toVal(output.unit)
          let parsedScript = Buffer.from(output.outputScript, "base64")
          let script = toASM(parsedScript, 0x01)
          let scriptType = getScriptType(parsedScript)

          if(scriptType === 'maker_output'){
            let maker = parseMakerLockScript(parsedScript);
            for(let addr of addresses){
              if('0x'+ blake2bl(blake2bl(addr) + addr) === maker.doubleHashedBcAddress) {
                maker.mine = true;
              }
            }
            maker.hash = tx.hash;
            maker.index = j;
            maker.value = value;
            maker.fixedUnitFee = new Decimal(maker.fixedUnitFee).div(new Decimal(Math.pow(10,18))).toString()
            maker.txHash = tx.hash;
            maker.txOutputIndex = j;
            maker.collateralizedNrg = value;
            maker.originalNrg = value;
            maker.owner = owner;
            maker.nrgUnit = unit;
            maker.tradeHeight = bcHeight;
            maker.addr = "Maker";
            maker.mempool = true;
            makers.push(Object.assign({},maker));

            if(!maker_map[`${maker.txHash}.${maker.txOutputIndex}`]) {
              addToPairs(maker,pairs,bcHeight)
              dispatch({type:ADD_TO_MAKER_MAP,payload:maker})
            }
          }

          if(scriptType === 'nrg_transfer'){
            let {doubleHashedBcAddress} = parseNRGLockScript(parsedScript);
            let added = false;
            for(let addr of addresses){
              if('0x'+ blake2bl(blake2bl(addr) + addr) === doubleHashedBcAddress) {
                transfers.push({owner,addr,index:j,hash:tx.hash,value});
                added = true;
              }
            }
            if(isOwner && !added){
              transfers.push({owner,addr:doubleHashedBcAddress,index:j,hash:tx.hash,value});
            }
          }

          if(scriptType === 'taker_output'){
            let taker = parseTakerLockScript(parsedScript);
            taker.maker = maker_map[`${taker.makerTxHash}.${taker.makerTxOutputIndex}`];

            if(!taker.maker) continue;
            for(let addr of addresses){
              if('0x'+ blake2bl(blake2bl(addr) + addr) === taker.maker.doubleHashedBcAddress) {
                taker.maker.mine = true;
              }
              if('0x'+ blake2bl(blake2bl(addr) + addr) === taker.doubleHashedBcAddress) {
                taker.mine = true;
              }
            }

            if(taker.maker.mine || taker.mine) {
              for(let j = 0; j < tx.inputsList.length; j++){
                let {hash,index,value} = tx.inputsList[j].outPoint
                if(hash === taker.makerTxHash || index === taker.makerTxOutputIndex){
                  let {sendsFromAddress,receivesToAddress} = parseTakerUnlockScript(Buffer.from(tx.inputsList[j].inputScript, "base64"))
                  taker.sendsFromAddress = sendsFromAddress;
                  taker.receivesToAddress = receivesToAddress;
                }
              }
            }

            let originalSends = new Decimal(taker.maker.sendsUnit).mul(new Decimal(taker.maker.originalNrg).div(new Decimal(taker.maker.collateralizedNrg)))
            if(taker.maker.oldSendsUnit){
              originalSends = new Decimal(taker.maker.oldSendsUnit).mul(new Decimal(taker.maker.originalNrg).div(new Decimal(taker.maker.collateralizedNrg)))
            }

            let originalReceives = new Decimal(taker.maker.receivesUnit).mul(new Decimal(taker.maker.originalNrg).div(new Decimal(taker.maker.collateralizedNrg)))

            if(taker.maker.oldReceivesUnit){
              originalReceives = new Decimal(taker.maker.oldReceivesUnit).mul(new Decimal(taker.maker.originalNrg).div(new Decimal(taker.maker.collateralizedNrg)))
            }

            let divider = new Decimal(taker.maker.originalNrg)
            .div((new Decimal(value).div(new Decimal(taker.maker.base))));

            taker.sendsAmount = originalSends.div(divider).toNumber()
            taker.receivesAmount = originalReceives.div(divider).toNumber();

            if(divider.eq(new Decimal(1))) {
              removeFromPairs(taker.maker,pairs)
            }
            else if(!maker_map[`${taker.makerTxHash}mod.${taker.makerTxOutputIndex}`]){
              dispatch({type:ADD_TO_MAKER_MAP,payload:{txHash:taker.makerTxHash+'mod',txOutputIndex: taker.makerTxOutputIndex}})
              modifyPairs(taker, pairs)
            }
            taker.hash = tx.hash;
            taker.index = j;
            taker.value = new Decimal(value).div(new Decimal(taker.maker.base)).toString();
            taker.owner = owner;
            taker.addr = "Taker";
            takers.push(taker)
          }
        }
      }
      // if(hash(pairs) != hash(store.getState().orderbook.pairs)){
      dispatch({type: FETCHED_PAIRS, payload: pairs});
      // }
      dispatch({type: MEM_MAKERS, payload: makers})
      dispatch({type: MEM_TAKERS, payload: takers})
      dispatch({type: MEM_TRANSFERS, payload: transfers})
      if(makers.length > 0 || takers.length > 0){
        console.log(makers.length, takers.length)
        await collateralizeFilter(dispatch,store.getState())
      }
    }
  }
},10000)
}
